export default "__VITE_ASSET__B1ZHe5a$__"